import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Truck, Shield, Wallet, RefreshCw, Sparkles } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const iconMap = {
  truck: Truck,
  shield: Shield,
  wallet: Wallet,
  refresh: RefreshCw,
  sparkles: Sparkles,
  check: Shield,
};

const AnnouncementBar = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/cms/announcement-bar`);
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to fetch announcement bar settings:', error);
      setSettings({
        enabled: true,
        background_color: '#800000',
        text_color: '#FFFFFF',
        items: [
          { text: 'Free Shipping on Orders Above ₹499', icon: 'truck', enabled: true },
          { text: 'Cash on Delivery Available', icon: 'wallet', enabled: true },
          { text: '100% Authentic Products', icon: 'shield', enabled: true },
        ],
        animation_speed: 30
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading || !settings?.enabled) return null;

  const enabledItems = settings.items?.filter(item => item.enabled) || [];
  if (enabledItems.length === 0) return null;

  const duplicatedItems = [...enabledItems, ...enabledItems, ...enabledItems];

  return (
    <div 
      className="relative overflow-hidden py-2"
      style={{ 
        backgroundColor: settings.background_color,
        color: settings.text_color 
      }}
      data-testid="announcement-bar"
    >
      <div 
        className="flex animate-scroll-left whitespace-nowrap"
        style={{ animationDuration: `${settings.animation_speed}s` }}
      >
        {duplicatedItems.map((item, index) => {
          const IconComponent = iconMap[item.icon] || Shield;
          return (
            <div 
              key={index} 
              className="flex items-center gap-2 mx-8 flex-shrink-0"
            >
              <IconComponent className="w-4 h-4" />
              <span className="text-sm font-medium">{item.text}</span>
              <span className="mx-4 opacity-40">|</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnnouncementBar;
